import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propArrayStr, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
const TypeFilter = (props) => {
    const { className, filters, onChange, types } = props;
    return (_jsx("div", Object.assign({ className: clsx('column_type_filter', className) }, { children: _jsx("ul", Object.assign({ className: 'filter_row' }, { children: filters.map(({ label, value }) => (_jsx("li", Object.assign({ className: 'filter_col' }, { children: _jsxs("label", Object.assign({ className: 'filter_label' }, { children: [_jsx("div", Object.assign({ className: 'column_type_text' }, { children: label })), _jsx("input", { checked: types.includes(value), className: 'filter_checkbox', id: `column_type_${value}`, name: 'columnType', onChange: onChange, type: 'checkbox', value: value }), _jsx("div", { className: 'filter_indicator' })] })) }), value))) })) })));
};
TypeFilter.propTypes = {
    className: propStr(),
    filters: propArrayShape().isRequired,
    onChange: propFunc().isRequired,
    types: propArrayStr().isRequired,
};
TypeFilter.defaultProps = {
    className: '',
};
export default TypeFilter;
